import * as React from "react"

function SvgComponent(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={52.075}
      height={44.735}
      viewBox="0 0 52.075 44.735"
      {...props}
    >
      <path
        data-name="Path 7994"
        d="M48.865.763H29.294a2.446 2.446 0 00-2.446 2.446v17.125a2.446 2.446 0 002.446 2.449h4.08v4.724a.408.408 0 00.7.288l5.012-5.012h9.785a2.446 2.446 0 002.446-2.446V3.209A2.446 2.446 0 0048.865.763z"
        fill="#edebed"
      />
      <path
        data-name="Path 7995"
        d="M37.867 35.919l-9.772-5.626a2.419 2.419 0 00-2.918.386l-2.529 2.529a2.136 2.136 0 01-2.854.148 57.144 57.144 0 01-8.415-8.415 2.136 2.136 0 01.148-2.854l2.529-2.529a2.42 2.42 0 00.386-2.918L8.816 6.871a2.42 2.42 0 00-3.808-.5l-2.9 2.9c-3.78 3.78.625 14.312 9.838 23.525s19.745 13.617 23.525 9.838l2.9-2.9a2.42 2.42 0 00-.504-3.815z"
        fill="#e6646e"
      />
      <path
        data-name="Path 7996"
        d="M13.985 30.751C4.772 21.538.368 11.006 4.147 7.226L2.109 9.265c-3.78 3.78.625 14.312 9.838 23.525s19.745 13.617 23.525 9.838l2.039-2.039c-3.781 3.779-14.313-.625-23.526-9.838z"
        fill="#dc4655"
      />
      <path
        data-name="Path 7997"
        d="M29.294 10.548V.763a2.446 2.446 0 00-2.446 2.446v17.125a2.446 2.446 0 002.446 2.449h4.08v4.724a.408.408 0 00.7.288l5.012-5.012h9.785a2.446 2.446 0 002.446-2.446H39.08a9.785 9.785 0 01-9.786-9.789z"
        fill="#dbd9dc"
      />
      <path
        data-name="Path 7998"
        d="M38.248 35.258l-9.772-5.626a3.188 3.188 0 00-3.838.508l-2.529 2.529a1.372 1.372 0 01-1.835.094 56.384 56.384 0 01-8.3-8.3 1.372 1.372 0 01.094-1.835l2.532-2.53a3.188 3.188 0 00.508-3.838L9.477 6.487a3.183 3.183 0 00-5.009-.662l-2.9 2.9c-4.14 4.14.181 14.947 9.838 24.6 7.177 7.177 14.989 11.407 20.227 11.406a5.971 5.971 0 004.377-1.568l2.9-2.9a3.182 3.182 0 00-.662-5.008zm-3.317 6.83c-1.572 1.572-4.813 1.495-8.891-.211a44.627 44.627 0 01-13.555-9.627 44.629 44.629 0 01-9.627-13.555c-1.706-4.079-1.783-7.32-.211-8.891l1.49-1.492.529.918a.763.763 0 101.322-.761l-.734-1.274.293-.293a1.643 1.643 0 011.167-.486 1.679 1.679 0 01.222.015 1.644 1.644 0 011.218.816l5.626 9.772a1.659 1.659 0 01-.264 2l-.924.924-4.974-8.64a.763.763 0 00-1.322.761l5.179 9-.487.487a2.9 2.9 0 00-.2 3.873 57.892 57.892 0 008.529 8.529 2.9 2.9 0 003.873-.2l.351-.352 1.884 1.075a.763.763 0 00.757-1.325l-1.521-.868 1.059-1.059a1.659 1.659 0 012-.264l9.772 5.626a1.656 1.656 0 01.345 2.607l-.387.387-8.367-4.775a.763.763 0 00-.756 1.325l8 4.568z"
      />
      <path
        data-name="Path 7999"
        d="M40.201 4.416a5.253 5.253 0 00-6.369 5.131.763.763 0 001.526 0 3.711 3.711 0 011.376-2.89 3.759 3.759 0 013.156-.748 3.724 3.724 0 01.224 7.214 2.42 2.42 0 00-1.8 2.317.763.763 0 001.526 0 .907.907 0 01.694-.85 5.25 5.25 0 00-.336-10.174z"
      />
      <path
        data-name="Path 8000"
        d="M39.088 17.602h-.008a.767.767 0 10.008 0z"
      />
      <path
        data-name="Path 8001"
        d="M48.865 0H29.294a3.213 3.213 0 00-3.209 3.209v17.125a3.213 3.213 0 003.209 3.209h3.318v3.961a1.17 1.17 0 002 .828l4.789-4.789h9.469a3.213 3.213 0 003.209-3.209V3.209A3.213 3.213 0 0048.865 0zm1.684 20.334a1.685 1.685 0 01-1.684 1.683H39.08a.763.763 0 00-.54.223l-4.406 4.406V22.78a.763.763 0 00-.763-.763h-4.077a1.685 1.685 0 01-1.682-1.683V3.209a1.685 1.685 0 011.683-1.683h19.571a1.685 1.685 0 011.684 1.683v17.125z"
      />
    </svg>
  )
}

const MemoSvgComponent = React.memo(SvgComponent)
export default MemoSvgComponent
